document.addEventListener("DOMContentLoaded", function () {

	//check table background
	document.querySelectorAll(".product-info__description .prose table").forEach(table => {
		if(Boolean(table.style.background)){
			table.classList.add('sc-table-row')
		}
	});

	//generate accordion
	document.querySelectorAll(".product-info__description[data-acc-tags] .prose").forEach(proseEl => {
		const parentWithData = proseEl.closest("[data-acc-tags]");
		const accTags = (parentWithData.getAttribute("data-acc-tags") || "")
      .split(",")
      .map(t => t.trim().toUpperCase())
      .filter(Boolean);

		if (!accTags.length) return;

		const children = Array.from(proseEl.children);
		const accordionContainer = document.createElement("div");
		const introContainer = document.createElement("div");

		let currentSection = null;
		let sectionIndex = 0;
		let foundFirstValidHeading = false;

		children.forEach(el => {
			const tag = el.tagName;

			//intro
			if (!foundFirstValidHeading) {
				if (accTags.includes(tag) && el.textContent.trim() !== "") {
					foundFirstValidHeading = true;
				} else {
					introContainer.appendChild(el);
					return;
				}
			}

			if (accTags.includes(tag) && el.textContent.trim() !== "") {

				currentSection = document.createElement("details");
				currentSection.className = "accordion group";
				currentSection.setAttribute("aria-expanded", "false");
				currentSection.setAttribute("is", "accordion-disclosure");

				if (sectionIndex === 0) {
					currentSection.setAttribute("open", "");
					currentSection.setAttribute("aria-expanded", "true");
				} else {
					currentSection.setAttribute("aria-expanded", "false");
				}

				//summary
				const headingClone = el.cloneNode(true);
				headingClone.classList.add("h2");

				const summary = document.createElement("summary");

				const toggle = document.createElement("div");
				toggle.className = "accordion__toggle";
				toggle.appendChild(headingClone);

				const chevron = document.createElement("span");
				chevron.className = "circle-chevron group-hover:colors group-expanded:colors";
				chevron.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="19.24" height="11.62" viewBox="0 0 19.24 11.62">
								<path id="Pfei" d="M0,15,8,7.5,0,0" transform="translate(2.12 9.5) rotate(-90)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
							</svg>`;

				toggle.appendChild(chevron);
				summary.appendChild(toggle);
				currentSection.appendChild(summary);

				//content
				const content = document.createElement("div");
				content.className = "accordion__content";
				currentSection.appendChild(content);

				accordionContainer.appendChild(currentSection);
				sectionIndex++;
			} else if (currentSection) {
				currentSection.querySelector(".accordion__content").appendChild(el);
			} else {
				
			}
		});

		proseEl.innerHTML = "";
		if (introContainer.children.length) {
			proseEl.appendChild(introContainer);
		}
		proseEl.appendChild(accordionContainer);
	});
});